import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { User } from '@/types/models/User';

const useUser = (authId: string | null | undefined) => {
  const client = supabaseClient;
  const queryKey = ['user', authId];

  const queryFn = async () => {
    return getUser(client, authId);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!authId,
  });
};

export default useUser;

function getUser(client: SupabaseClient, authId: string | null | undefined): User | null {
  return client
    .from('users')
    .select(
      `
        id,
        auth_id,
        type,
        restaurant_id,
        created_at
      `
    )
    .eq('auth_id', authId)
    .maybeSingle()
    .then((result) => result?.data ?? null) as unknown as User | null;
}
